export default __webpack_public_path__ + "static/media/errorbackground.563926ef.png";